var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","name":"file"},on:{"change":_vm.uploadFile}})}
var staticRenderFns = []

export { render, staticRenderFns }